// External destinations and contact details
export const BOARDROOM_BASE = "https://boardroom.c-ore.in";
export const SIGNUP_URL = `${BOARDROOM_BASE}/signup`;
export const SIGNUP_TRIAL_URL = `${BOARDROOM_BASE}/signup?plan=trial`;
export const SIGNUP_PULSE_URL = `${BOARDROOM_BASE}/signup?plan=pulse`;
export const SIGNUP_COMMAND_URL = `${BOARDROOM_BASE}/signup?plan=command`;
export const SIGNUP_SOVEREIGN_URL = `${BOARDROOM_BASE}/signup?plan=sovereign`;
export const SIGNUP_LIFETIME_URL = `${BOARDROOM_BASE}/signup?plan=lifetime`;
export const LOGIN_URL = `${BOARDROOM_BASE}/login`;
export const DEMO_URL = `${BOARDROOM_BASE}/executive?demo=true`;

export const HELP_EMAIL = "help@c-ore.in";
export const FOUNDER_EMAIL = "founder@c-ore.in";
export const PARTNER_EMAIL = "partner@c-ore.in";
export const PHONE_DIGITS = "919371880369";
export const PHONE_DISPLAY = "+91 93718 80369";
export const WHATSAPP_URL = `https://wa.me/${PHONE_DIGITS}`;
